/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BasicInfo } from './BasicInfo';
import {
    BasicInfoFromJSON,
    BasicInfoFromJSONTyped,
    BasicInfoToJSON,
} from './BasicInfo';
import type { Demographics } from './Demographics';
import {
    DemographicsFromJSON,
    DemographicsFromJSONTyped,
    DemographicsToJSON,
} from './Demographics';
import type { Diagnosis } from './Diagnosis';
import {
    DiagnosisFromJSON,
    DiagnosisFromJSONTyped,
    DiagnosisToJSON,
} from './Diagnosis';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
} from './Document';
import type { PayorSource } from './PayorSource';
import {
    PayorSourceFromJSON,
    PayorSourceFromJSONTyped,
    PayorSourceToJSON,
} from './PayorSource';
import type { ReferralSource } from './ReferralSource';
import {
    ReferralSourceFromJSON,
    ReferralSourceFromJSONTyped,
    ReferralSourceToJSON,
} from './ReferralSource';

/**
 * 
 * @export
 * @interface PatientInput
 */
export interface PatientInput {
    /**
     * 
     * @type {string}
     * @memberof PatientInput
     */
    service_line: string;
    /**
     * 
     * @type {BasicInfo}
     * @memberof PatientInput
     */
    basic_info: BasicInfo;
    /**
     * 
     * @type {Demographics}
     * @memberof PatientInput
     */
    demographics: Demographics;
    /**
     * 
     * @type {Array<Document>}
     * @memberof PatientInput
     */
    documents?: Array<Document>;
    /**
     * 
     * @type {ReferralSource}
     * @memberof PatientInput
     */
    referral: ReferralSource;
    /**
     * 
     * @type {Array<PayorSource>}
     * @memberof PatientInput
     */
    payor_sources?: Array<PayorSource>;
    /**
     * 
     * @type {Array<Diagnosis>}
     * @memberof PatientInput
     */
    diagnoses: Array<Diagnosis>;
    /**
     * 
     * @type {string}
     * @memberof PatientInput
     */
    requested_date_of_evaluation: string;
}

/**
 * Check if a given object implements the PatientInput interface.
 */
export function instanceOfPatientInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "service_line" in value;
    isInstance = isInstance && "basic_info" in value;
    isInstance = isInstance && "demographics" in value;
    isInstance = isInstance && "referral" in value;
    isInstance = isInstance && "diagnoses" in value;
    isInstance = isInstance && "requested_date_of_evaluation" in value;

    return isInstance;
}

export function PatientInputFromJSON(json: any): PatientInput {
    return PatientInputFromJSONTyped(json, false);
}

export function PatientInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'service_line': json['service_line'],
        'basic_info': BasicInfoFromJSON(json['basic_info']),
        'demographics': DemographicsFromJSON(json['demographics']),
        'documents': !exists(json, 'documents') ? undefined : ((json['documents'] as Array<any>).map(DocumentFromJSON)),
        'referral': ReferralSourceFromJSON(json['referral']),
        'payor_sources': !exists(json, 'payor_sources') ? undefined : ((json['payor_sources'] as Array<any>).map(PayorSourceFromJSON)),
        'diagnoses': ((json['diagnoses'] as Array<any>).map(DiagnosisFromJSON)),
        'requested_date_of_evaluation': json['requested_date_of_evaluation'],
    };
}

export function PatientInputToJSON(value?: PatientInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'service_line': value.service_line,
        'basic_info': BasicInfoToJSON(value.basic_info),
        'demographics': DemographicsToJSON(value.demographics),
        'documents': value.documents === undefined ? undefined : ((value.documents as Array<any>).map(DocumentToJSON)),
        'referral': ReferralSourceToJSON(value.referral),
        'payor_sources': value.payor_sources === undefined ? undefined : ((value.payor_sources as Array<any>).map(PayorSourceToJSON)),
        'diagnoses': ((value.diagnoses as Array<any>).map(DiagnosisToJSON)),
        'requested_date_of_evaluation': value.requested_date_of_evaluation,
    };
}

